export class UpdateProjectConfigurationKeyRequest {
    'key';
    'value';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "key",
            "baseName": "key",
            "type": "ProjectConfigurationKeyEnum",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateProjectConfigurationKeyRequest.attributeTypeMap;
    }
    constructor() {
    }
}
